import { RefObject, useEffect, useState } from 'react';
interface HorizontalOverflowState {
  isOverflowing: boolean;
  canScrollLeft: boolean;
  canScrollRight: boolean;
}

const useHorizontalOverflowDetect = (containerRef: RefObject<HTMLElement>): HorizontalOverflowState => {
  const [overflowState, setOverflowState] = useState<HorizontalOverflowState>({
    isOverflowing: false,
    canScrollLeft: false,
    canScrollRight: false,
  });

  useEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        const scrollWidth = containerRef.current.scrollWidth;
        const scrollLeft = containerRef.current.scrollLeft;

        let childrenWidth = 0;

        for (let i = 0; i < containerRef.current.children.length; i++) {
          const child = containerRef.current.children[i];
          const style = getComputedStyle(child);
          const marginLeft = parseInt(style.marginLeft, 10) || 0;
          const marginRight = parseInt(style.marginRight, 10) || 0;

          // @ts-ignore
          childrenWidth += child.offsetWidth + marginLeft + marginRight;
        }

        const isOverflowing = childrenWidth > containerWidth;
        const canScrollLeft = scrollLeft > 0;
        const canScrollRight = scrollLeft + containerWidth < scrollWidth;

        setOverflowState({
          isOverflowing,
          canScrollLeft,
          canScrollRight,
        });
      }
    };

    checkOverflow(); // Initial check

    const handleScroll = () => {
      checkOverflow();
    };

    const handleResize = () => {
      checkOverflow();
    };

    // Attach scroll event listener
    if (containerRef.current) {
      containerRef.current.addEventListener('scroll', handleScroll);
    }

    window.addEventListener('resize', handleResize);

    const resizeObserver = new ResizeObserver(checkOverflow);

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      window.removeEventListener('resize', handleResize);

      if (containerRef.current) {
        containerRef.current.removeEventListener('scroll', handleScroll);
      }

      resizeObserver.disconnect();
    };
  }, [containerRef]);

  return overflowState;
};

export default useHorizontalOverflowDetect;
